<template>
  <div>
  <div class="list_container" v-if="view.config.data && items" v-resize="onResize">
    <ul class="items">
      <input @click="selected = 0" placeholder="search" v-model="search" />
      <li @click="selected = index" :class="{active: selected == index}" v-for="(item, index) in filtered" :key="index">
        <p class="font-bold">{{item.title}}</p>
        <p>{{item.author}}</p>
      </li>
    </ul>
    <div class="selected">
      <h1>{{filtered[selected].title}} <span>({{filtered[selected].date}})</span> </h1>
      <h2>{{filtered[selected].author}}</h2>
      <div v-html="filtered[selected].text"></div>
    </div>
  </div>
  <div class="list_container" v-if="view.config.tag && items" v-resize="onResize">
    <ul class="items">
      <input @click="selected = 0" placeholder="search" v-model="search" />
      <li @click="selected = index" :class="{active: selected == index}" v-for="(item, index) in filtered" :key="index">
        <p class="font-bold">{{item.title}}</p>
        <p>{{getAuthor(item.author)}}</p>
      </li>
    </ul>
    <div class="selected">
      <h1><a :href="'https://live.edgeryders.eu/paper/' + filtered[selected].id">{{filtered[selected].title}}</a></h1>
      <p>{{filtered[selected].date | formatDate }} - Posted by <a :href="'https://edgeryders.eu/u/' + getUsername(filtered[selected].author)">{{getAuthor(filtered[selected].author)}}</a></p>
      <div v-html="filtered[selected].text"></div>
    </div>
  </div>
</div>
</template>

<script>
import moment from "moment";
export default {
  name: "list",
  data() {
    return {
      items: null,
      users: null,
      selected: 0,
      keysToSearch: ['title', 'author'],
      search: ''
    };
  },
  props: ["view"],
  components: {
  },
  methods: {
    getData(id) {
      var self = this;
      fetch("https://edgeryders.eu/raw/" + id + ".json")
        .then((response) => {
          response.text().then(function(text) {
            if (self.parseJson(text)){
              self.items = self.parseJson(text).data;
            }
            else {
              self.items = self.parseTable(text);
            }
          });
        })
        .catch((error) => console.error(error));
    },
    parseTable(text){
      var html = window.md.render(text);
      const doc = new DOMParser().parseFromString(html, "text/xml");
      var keys = Array.prototype.map.call(doc.querySelectorAll('th'), function(th){
        return th.innerHTML;
      });
      var data = Array.prototype.map.call(doc.querySelector('tbody').querySelectorAll('tr'), function(tr){
        var obj = new Object();
        Array.prototype.map.call(tr.querySelectorAll('td'), function(td, index){
          var key = keys[index];
          obj[key] = td.innerHTML;
        });
        return obj;
      });
      return data;
    },
    getUsername(userid) {
      return this.users.filter((x) => x.id == userid)[0].username;
    },
    getAuthor(userid) {
      return this.users.filter((x) => x.id == userid)[0].name || '@' + this.users.filter((x) => x.id == userid)[0].username ;
    },
    createItem(item) {
      var doc = document.createElement("div");
      doc.innerHTML = item.excerpt;

      var obj = {
        title: item.title,
        image: item.image_url,
        date: item.created_at,
        text: doc.innerHTML,
        id: item.id,
        url: "https://edgeryders.eu/t/" + item.slug,
        author: item.posters[0].user_id,
        likes: item.like_count,
      };
      return obj;
    },
    getTopics(tag) {
      var self = this;
      fetch("https://edgeryders.eu/tag/" + tag + ".json")
        .then((response) => response.json())
        .then((data) => {
          var array = data.topic_list.topics.map((x) => self.createItem(x));
          self.items = array.sort((a, b) => b.date.localeCompare(a.date));
          self.users = data.users;
        });
    },
    parseJson(value) {
      var code = value.match(/```([^`]*)```/);
      if (code) {
        return JSON.parse(code[1]);
      } else {
        return false;
      }
    },
    onResize({ width }) {
      if (width < 500) {
        this.viewport = 'mobile'
        this.card_count = this.items.length;
        this.parallax = false;
      }
    }
  },
  mounted() {
    var width = window.innerWidth;
    if (width < 600) {
      this.viewport = 'mobile'
    }
    if (this.view.config.data) {
      this.getData(this.view.config.data);
    }
    if (this.view.config.tag) {
      this.keysToSearch = ['title'];
      this.getTopics(this.view.config.tag);
    }
  },
  computed: {
    filtered(){
     return this.items.filter(item =>
        this.keysToSearch.some(key => item[key].toLowerCase().includes(this.search.toLowerCase()))
      );
    }
  },
  filters: {
    formatDate: function(value) {
      return moment(String(value)).format("DD/MM/YY");
    }
  }
};
</script>

<style lang="scss">
.list_container {
  @apply border rounded-lg relative mb-8 overflow-hidden flex;
  max-height: 400px;
  min-height: 400px;
  width: 100%;
  margin-left: 0%;
  ul {
   @apply border-r w-full;
   width: 260px;
   flex-shrink: 0;
   padding: 0px 0 0 0 !important;
   margin: 0 !important;

   overflow-y: scroll;
   input {
   @apply border-b w-full p-3 px-4 text-base font-bold;
   top: 0;
 }
   li {
     list-style-type: none;
     padding: 0;
     margin: 0 !important;
     @apply leading-tight px-4 py-3 pr-2 text-base w-full border-b inline-block;
     &.active {
      background: #efefef;
     }
  
     &:nth-child(odd){
     background: #fafafa;
   }
     &:hover {
     cursor: pointer;
     background: #efefef;
   }
   &:last-child {
   border: none;
 }
 h1 {
 @apply leading-tight;
}
     p {
       @apply text-base leading-tight;
       margin: 0 !important;
      }
    }
  }
  .selected {
   @apply p-6;
   overflow-y: scroll;
   p {
    @apply text-base;
   }
   h1 {
     @apply text-xl;
     margin: 0;
     padding: 0;
   }
   h2 {
    color: rgba(0,0,0,0.8);
   }
  }
}



</style>
